module.exports = __webpack_public_path__ + "img/mining-puppet-logo.61dc3919.png";